import { render, staticRenderFns } from "./SithMesStoolVendorEdit.vue?vue&type=template&id=478c1370&"
import script from "./SithMesStoolVendorEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesStoolVendorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports